import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row} from "reactstrap";
import RecentAgencies from "./RecentAgencies";
import RecentTemplates from "./RecentTemplates";
import { ADMIN_DASHBOARD,ADMIN_DASHBOARD_REPORT } from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import MonthVsPayments from "./MonthVsPayments";


export default function AdminDashBoard() {
  const [list, setList] = useState({});
  const [loading, setLoading] = useState(false);
  const [datas, setdatas] = useState([]);
  const callAPI = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: ADMIN_DASHBOARD,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        setList(response.data);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const DashBoard = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: ADMIN_DASHBOARD_REPORT,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status,monthwisePaymentReport } = response.data;
      if (status === "Success") {
        const value=monthwisePaymentReport.map((i)=>({paymentDate:i.report,amount:i.amount}))
       setdatas(value)
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    callAPI();
    DashBoard();
  }, []);

  const {
    recentTemplate = [],
    recentAgency = [],
    totalAgency = 0,
    totalCustomer = 0,
    totalPayment = 0,
  } = list;

  return (
    <div>
      {loading && <CustomPageLoading />}

      <div className="wrapper">
        <Container fluid>
          <Row className="mt-4">
            <Col lg="12" xl="8" className="order2-1199">
            
               <MonthVsPayments loading={loading} data={datas} />
            </Col>
            <Col lg="12" xl="4">
              <div className="dash-count">
                <div className="box">
                  <Link
                    style={{ textDecoration: "none" }}
                    to={{
                      pathname: "/admin/agency",
                    }}
                  >
                    <span>Agency</span>
                    <h3>{totalAgency}</h3>
                    <span className="circle">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>
                    </span>
                  </Link>
                </div>

                <div className="box">
                <Link>
                  <span>Customer</span>
                  <h3>{totalCustomer}</h3>
                  <span className="circle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M544 224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm-304-48c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80-80 35.8-80 80zm128 0c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zM96 384c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm468 160h-40c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zm-448 0H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zm224 0h-40c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM64 48c0-8.83 7.19-16 16-16h480c8.81 0 16 7.17 16 16v149.22c11.51 3.46 22.37 8.36 32 15.11V48c0-26.47-21.53-48-48-48H80C53.53 0 32 21.53 32 48v164.33c9.63-6.75 20.49-11.64 32-15.11V48z"/></svg>
                  </span>
                  </Link>
                </div>

                <div className="box">
                <Link>
                  <span>Total Amount</span>
                  <h3>${parseFloat(totalPayment).toFixed(2)}</h3>
                  <span className="circle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm40.3-221.3l-72-20.2c-12.1-3.4-20.6-14.4-20.6-26.7 0-15.3 12.8-27.8 28.5-27.8h45c11.2 0 21.9 3.6 30.6 10.1 3.2 2.4 7.6 2 10.4-.8l11.3-11.5c3.4-3.4 3-9-.8-12-14.6-11.6-32.6-17.9-51.6-17.9H264v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-7.8c-33.3 0-60.5 26.8-60.5 59.8 0 26.6 18.1 50.2 43.9 57.5l72 20.2c12.1 3.4 20.6 14.4 20.6 26.7 0 15.3-12.8 27.8-28.5 27.8h-45c-11.2 0-21.9-3.6-30.6-10.1-3.2-2.4-7.6-2-10.4.8l-11.3 11.5c-3.4 3.4-3 9 .8 12 14.6 11.6 32.6 17.9 51.6 17.9h5.2v40c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40h7.8c33.3 0 60.5-26.8 60.5-59.8-.1-26.6-18.1-50.2-44-57.5z"/></svg>
                  </span>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md="12" lg="6" xl="7">
              {/* RecentTemplates */}
              <RecentTemplates loading={loading} recentTemplate={recentTemplate} />
              {/* RecentTemplates */}
            </Col>
            <Col md="12" lg="6" xl="5">
              {/* RecentAgencies */}
              <RecentAgencies loading={loading} recentAgency={recentAgency} />
              {/* RecentAgencies */}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
